/** The authorize endpoint rejected the Azure token as expired: re-acquire it. */
export class AuthExpiredError extends Error {
  constructor(message = 'Azure token is expired.', options?: ErrorOptions) {
    super(message, options)
    this.name = 'AuthExpiredError'
  }
}

/** No Oase token, or it could not be refreshed: the session is over. */
export class SessionExpiredError extends Error {
  constructor(message = 'Session expired', options?: ErrorOptions) {
    super(message, options)
    this.name = 'SessionExpiredError'
  }
}
